import './Skeleton.css';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
  animation?: 'pulse' | 'wave' | 'none';
  className?: string;
  lines?: number; // Para múltiples líneas de texto
}

export default function Skeleton({
  width,
  height,
  variant = 'rectangular',
  animation = 'pulse',
  className = '',
  lines,
}: SkeletonProps) {
  const style: React.CSSProperties = {
    width: width || (variant === 'circular' ? '40px' : '100%'),
    height: height || (variant === 'circular' ? '40px' : '20px'),
  };

  const baseClass = `skeleton skeleton-${variant} skeleton-${animation}`;

  if (lines && lines > 1) {
    return (
      <div className={`skeleton-container ${className}`}>
        {Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className={baseClass}
            style={{
              ...style,
              width: index === lines - 1 ? '80%' : '100%',
              marginBottom: index < lines - 1 ? '8px' : '0',
            }}
          />
        ))}
      </div>
    );
  }

  return <div className={`${baseClass} ${className}`} style={style} />;
}

// Componentes predefinidos para casos comunes
export function SkeletonTable({ rows = 5, columns = 4 }: { rows?: number; columns?: number }) {
  return (
    <div className="skeleton-table">
      <div className="skeleton-table-header">
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={i} height="40px" variant="rectangular" className="skeleton-table-cell" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="skeleton-table-row">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton
              key={colIndex}
              height="48px"
              variant="rectangular"
              className="skeleton-table-cell"
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <Skeleton height="200px" variant="rounded" className="skeleton-card-image" />
      <div className="skeleton-card-content">
        <Skeleton height="24px" width="60%" className="skeleton-card-title" />
        <Skeleton lines={3} className="skeleton-card-text" />
      </div>
    </div>
  );
}

export function SkeletonList({ items = 5 }: { items?: number }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: items }).map((_, i) => (
        <div key={i} className="skeleton-list-item">
          <Skeleton variant="circular" width="48px" height="48px" />
          <div className="skeleton-list-content">
            <Skeleton height="16px" width="60%" />
            <Skeleton height="14px" width="40%" className="skeleton-list-subtitle" />
          </div>
        </div>
      ))}
    </div>
  );
}

